export default "__VITE_ASSET__COiKuIsi__"